import React from "react";
import { Box, Typography, useMediaQuery, useTheme } from "@mui/material";
import { styled } from "@mui/system";

interface ZipangRedirectFooterProps {
  handleWebRedirect: () => void;
  handleAppRedirect: () => void;
  themeColor?: string;
}

const StyledIcon = styled("img")({
  width: 30,
  height: 30,
});

const ZipangRedirectFooter: React.FC<ZipangRedirectFooterProps> = ({
  handleWebRedirect,
  handleAppRedirect,
  themeColor = "#0052cc", // default theme
}) => {
  const layout = useTheme();
  const isMobileRedirectVisible = useMediaQuery(
    layout.breakpoints.between("xs", "lg")
  );
  return (
    <Box
      sx={{
        width: "100%",
        backgroundColor: themeColor,
        color: "white",
        px: { xs: 3, sm: 6, md: 10 },
        py: { xs: 3, sm: 4 },
        display: "flex",
        flexDirection: { xs: "column", md: "row" },
        alignItems: "center",
        justifyContent: "space-between",
        rowGap: 2,

        "@media (min-width: 894px) and (max-width: 1075px)": {
          flexDirection: "column",
        },
      }}
    >
      {/* Text Section */}
      <Box sx={{ flex: 1, textAlign: { xs: "center", md: "left" } }}>
        <Typography
          variant="h6"
          sx={{
            fontWeight: "bold",
            fontSize: { xs: 16, sm: 18, md: 20 },
            mb: 1,
          }}
        >
          Get the Full Experience
        </Typography>
        <Typography sx={{ fontSize: { xs: 14, sm: 16 } }}>
          To view full details before you place your bid, please login via app
          or web.
        </Typography>
      </Box>

      {/* Buttons Section */}
      <Box
        sx={{
          display: "flex",
          flexDirection: { xs: "column", sm: "row" },
          gap: 2,
          mt: { xs: 2, md: 0 },
        }}
      >
        {/* Continue with Browser Button */}
        <Box
          onClick={handleWebRedirect}
          sx={{
            display: "flex",
            flexDirection: "row",
            alignItems: "center",
            gap: 1.5,
            backgroundColor: "white",
            borderRadius: "20px",
            padding: "5px 15px",
            cursor: "pointer",
            userSelect: "none",
            border: `1px solid ${themeColor}`,
          }}
        >
          <StyledIcon src="/images/svgimages/browser.svg" alt="Browser Icon" />
          <Typography
            sx={{
              color: themeColor,
              fontSize: { sm: 15, md: 25 },
              fontWeight: 500,
            }}
          >
            Navigate to Website
          </Typography>
        </Box>

        {/* Continue with App Button */}
        {isMobileRedirectVisible && (
          <Box
            onClick={handleAppRedirect}
            sx={{
              display: "flex",
              flexDirection: "row",
              alignItems: "center",
              gap: 1.5,
              backgroundColor: "white",
              borderRadius: "20px",
              padding: "5px 15px",
              cursor: "pointer",
              userSelect: "none",
              border: `1px solid ${themeColor}`,
            }}
          >
            <img
              src="/images/zipangLogo.png"
              alt="App Icon"
              width={30}
              height={30}
            />
            <Typography
              sx={{
                color: themeColor,
                fontSize: { sm: 15, md: 25 },
                fontWeight: 500,
              }}
            >
              Continue with App
            </Typography>
          </Box>
        )}
      </Box>
    </Box>
  );
};

export default ZipangRedirectFooter;
